import { memo, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FormField from "layouts/Flow Designer/components/FormField";
import SoftBox from "components/SoftBox";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import { form } from "../schemas/form";
import OptionLabel from "./OptionLabel";
import StyledDivider from "./StyledDivider";
import { TRIGGER_RESPONSE_CODES } from "constants/flowDesigner";

const ResponseCode = ({ allowEditWorkflow }) => {
  const [defaultValue, setDefaultValue] = useState({});
  const formRef = useContext(FormFieldsContext);
  const { responseCode, customResponseCode } = form.formField;
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const setResponceCodeDefaultValue = () => {
    const value = responseCode.options.find(
      (option) => option.value === formRef?.values?.responseCode
    );
    setDefaultValue(value);
  };

  useEffect(() => {
    if (formRef?.values) {
      setResponceCodeDefaultValue();
    }
  }, [formRef?.values?.responseCode]);

  return (
    <>
      <OptionLabel label={responseCode.label} name={responseCode.name} allowEditWorkflow={allowEditWorkflow}/>
      <SoftBox sx={{ display: "flex", width: "100%", alignItems: "center" }}>
        <FormField
          style={{ width: "100%" }}
          className="response-code-input"
          type={responseCode.type}
          label={""}
          name={responseCode.name}
          error={formRef?.errors?.responseCode && formRef?.touched?.responseCode}
          placeholder=""
          options={responseCode.options}
          defaultValue={defaultValue}
          value={defaultValue}
          isDisabled={isFlowActive || !allowEditWorkflow}
        />
      </SoftBox>
      {formRef?.values?.responseCode === TRIGGER_RESPONSE_CODES.CUSTOM && (
        <FormField
          type={customResponseCode.type}
          label={customResponseCode.label}
          name={customResponseCode.name}
          error={formRef?.errors?.customResponseCode && formRef?.touched?.customResponseCode}
          placeholder=""
          disabled={isFlowActive || !allowEditWorkflow}
        />
      )}
      <StyledDivider />
    </>
  );
};

export default memo(ResponseCode);
